import { getCurrentToken } from '@infinitro/global';
import { getCurrentSupportChatActor, supportChatHttpUrl } from '../api/http';
/** Builds an authenticated `<img src>` URL for customer attachment serve paths. */
export function resolveSupportChatAttachmentUrl(relativeUrl) {
    const path = relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`;
    const actor = getCurrentSupportChatActor();
    const actorKind = path.startsWith('/player/') || path.startsWith('/guest/') ? undefined : actor?.kind;
    const base = supportChatHttpUrl(path, actorKind);
    const token = actor?.kind === 'player' ? actor.token : getCurrentToken();
    const guestDeviceId = actor?.kind === 'guest' ? actor.deviceId : '';
    if (!token && !guestDeviceId)
        return base;
    const sep = base.includes('?') ? '&' : '?';
    if (guestDeviceId)
        return `${base}${sep}device_id=${encodeURIComponent(guestDeviceId)}`;
    return `${base}${sep}token=${encodeURIComponent(token ?? '')}`;
}
